import React from 'react'
import Announcement from '../components/Main/Announcement'
import CtaBanner from '../components/Main/CtaBanner'
import RowList from '../components/Main/RowList'
import Page from '../components/Page'

export default function Scholarships (props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //Announcements
    announcement_heading: announceHeading,
    announcement_body: announceBody,

    //RowList Scholarships Repeater
    scholarships: scholarships,
    inactive_button_text: inactiveText,

    //CtaBanner
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.acf

  return (
    <Page
      title={introHeading}
      body={introParagraph}
      bgImage={introImage}
      bgId={imageId}
      alt={alt}
      height={height}
      width={width}
      slug={'/' + introHeading}
    >
      <main id='content'>
        <a className='skip' id='skip'></a>
        <div className='scholarship-list container-fluid'>
          <Announcement title={announceHeading} body={announceBody} />

          {scholarships.map(scholarships => (
            <RowList
              scholarship
              key={scholarships.scholarship_name}
              title={scholarships.scholarship_name}
              body={scholarships.scholarship_description}
              link={scholarships.scholarship_link.url}
              button={scholarships.scholarship_link.title}
              active={scholarships.scholarship_active}
              inactiveText={inactiveText}
            />
          ))}
        </div>
      </main>
      <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
    </Page>
  )
}
